import { createContext } from 'react'

const ParticipantContext = createContext()

export default ParticipantContext
